import { Col, Container, Row } from "react-bootstrap";
import vod from "../../assets/img/VOD.png";

export default function VOD() {
  return (
    <Container fluid>
      <Row style={{ textAlign: "justify" }}>
        <Col
          style={{
            display: " flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          xs={12}
          md={6}
        >
          <img src={"https://chatbot.ddishtv.mn/kinosan.png"} alt="" />
        </Col>
        <Col xs={12} md={6}>
          <Row>
            <h2>Film fund</h2>
            <p>
              <p>
                The Movie Library service has been available to users since
                2018, and allows users to download any movie they want at any
                time. The user can use this service by plugging in a flash drive
                with a capacity of more than 32GB and an internet connection to
                the device. It is characterized by the fact that you can watch
                the rented movie as many times as you like within 72 hours.
              </p>

              <p>
                Package Activation Steps:
                <br /> 1. Rent with your TV remote control
                <br /> 2. You can rent by sending a message from the admin
                number.
              </p>
              <p>
                Features of the movie library: By connecting a flash drive with
                a capacity of more than 32GB and an Internet connection to the
                receiving device, it is possible to fill the movie library with
                the movies you want. In addition, users of the Home Full service
                can download movies at night without losing data. The number of
                movies copied to the movie library varies depending on the
                capacity of the flash drive connected to the receiving device.
              </p>
            </p>
          </Row>
        </Col>
      </Row>
      <hr />
    </Container>
  );
}
